import { DemographicsUserBasedCompare } from "app/pages/website-analysis/demographicsUserBased/DemographicsUserBasedCompare";
import { DemographicsUserBasedSingle } from "app/pages/website-analysis/demographicsUserBased/DemographicsUserBasedSingle";
import { isCompareMode } from "app/UtilitiesAndConstants/UtilityFunctions/isCompareMode";

export const DemographicsUserBased = () => {
    return isCompareMode() ? <DemographicsUserBasedCompare /> : <DemographicsUserBasedSingle />;
};
